// deno-lint-ignore-file ban-unused-ignore no-explicit-any no-empty-interface
///////////////////////////////////
// !!! DO NOT EDIT THIS FILE !!! //
///////////////////////////////////

import type { SlackAPIResponse } from "../response";
export type ChatMeMessageResponse = SlackAPIResponse & {
  channel?: string;
  error?: string;
  needed?: string;
  ok: boolean;
  provided?: string;
  ts?: string;
};
